import React from "react";
import LendbotDisabled from "@app/app/modules/assets/svg/lendbotDisabled";
import GetDataDisabled from "@app/app/modules/assets/svg/getDataDisabled";
import TouDisabled from "@app/app/modules/assets/svg/touDisabled";
import ConsentDisabled from "@app/app/modules/assets/svg/consentDisabled";
import ConnectDisabled from "@app/app/modules/assets/svg/connectDisabled";
import AccordDisabled from "@app/app/modules/assets/svg/accordDisabled";
import JscypherDisabled from "@app/app/modules/assets/svg/jscypherDisabled";
import FaceSignDisabled from "@app/app/modules/assets/svg/faceSignDisabled";
import VizdataDisabled from "@app/app/modules/assets/svg/vizdataDisabled";
import RulesDisabled from "@app/app/modules/assets/svg/rulesDisabled";


const disabledIconsMap = {
  getdata: <GetDataDisabled />,
  facesign: <FaceSignDisabled />,
  lendbot: <LendbotDisabled />,
  accord: <AccordDisabled />,
  connect: <ConnectDisabled />,
  consent: <ConsentDisabled />,
  tou: <TouDisabled />,
  jscipher: <JscypherDisabled />,
  vizdata: <VizdataDisabled />,
  fleet: <RulesDisabled/>
};

export default function getProductDisabledIcon(code) {
  return disabledIconsMap[code] || <span>ups!</span>;
}
